/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tut_Santai_S3Inputs */

const en_tut_santai_s3 = /** @type {(inputs: Tut_Santai_S3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Play **Pola Bersama**: press **Mulai dan bergabung**, then tap tiles on a nine-light board — each tap flips that light and its neighbours. You win when every light is off.`)
};

const id_tut_santai_s3 = /** @type {(inputs: Tut_Santai_S3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Main **Pola Bersama**: tekan **Mulai dan bergabung**, lalu tekan petak pada papan sembilan lampu — setiap tekan membalik lampu itu dan tetangganya. Menang saat semua lampu padam.`)
};

/**
* | output |
* | --- |
* | "Play **Pola Bersama**: press **Mulai dan bergabung**, then tap tiles on a nine-light board — each tap flips that light and its neighbours. You win when every..." |
*
* @param {Tut_Santai_S3Inputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const tut_santai_s3 = /** @type {((inputs?: Tut_Santai_S3Inputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tut_Santai_S3Inputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_tut_santai_s3(inputs)
	return en_tut_santai_s3(inputs)
});